import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ReactComponent as CircleIcon } from '../../../assets/images/circle.svg';
import { onChangeParkingsAlertsDeviceFilter } from '../../../ac/onChangeMapFilters';
import { ParkingsAlertsDeviceFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const CircleLegend = ({ fill }) => (
    <CircleIcon
        fill={fill}
        width='2vw'
        height='2vw'
        opacity='0.8'
    />
);
const ParkingsAlertsPointsDeviceFilterComponent = ({
    mapFilters,
    onChangeParkingsAlertsDeviceFilter,
}) => (
    <div>
        <div className={styles.checkboxIconGrid}>
            {
                ParkingsAlertsDeviceFilterValues.map(({ value, fill, label }) => (
                    <Fragment key={value}>
                        <CircleLegend
                            fill={fill}
                            width='2vw'
                            height='2vw'
                            opacity='0.8'
                        />
                        <label htmlFor={label.id}>{i18n._(label)}</label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    name='poi'
                                    id={value}
                                    checked={mapFilters.ParkingsAlertsPointsDeviceStatuses.includes(value)}
                                    value={value}
                                    onChange={onChangeParkingsAlertsDeviceFilter}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))
            }
        </div>
        <div style={{ padding: '10px' }}>
            <span className={styles.legendSubtitle}>{t`Используются алерты попыток парковок со статусом DENIED.`}</span>
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingsAlertsDeviceFilter })(ParkingsAlertsPointsDeviceFilterComponent);

export const ParkingsAlertsPointsDeviceFilter = withDisplayedLayersCheck(ConnectedComponent, t`Алерты завершения парковки`);
